// --- Helpers ---
/**
 * @description Gets stores that are currently visible within the map viewport
 * @param {Object} map - Google Map instance
 * @param {Array} allStores - Array of all store objects
 * @returns {Array} Stores within the current viewport bounds
 */
export const getViewportStores = (map, allStores) => {
  if (!map || !allStores || !Array.isArray(allStores)) {
    return [];
  }

  const bounds = map?.getBounds?.();

  // If bounds are not available yet, return all stores
  if (!bounds || typeof bounds.contains !== 'function') {
    console.warn('Map bounds not available yet, returning all stores');
    return allStores;
  }

  const { LatLng } = window.google.maps;
  if (!LatLng) {
    console.warn('Google Maps LatLng not available');
    return allStores;
  }

  // Filter stores within bounds
  const viewportStores = allStores.filter((store) => {
    const lat = Number(store.latitude);
    const lng = Number(store.longitude);

    try {
      const position = new LatLng(lat, lng);
      return bounds.contains(position);
    } catch (error) {
      console.error('Error checking store bounds:', error);
      return false;
    }
  });

  return viewportStores;
};

/**
 * @description Filters stores by active tags
 * @param {Array} stores - Array of store objects
 * @param {Set} activeTags - Set of active tag names
 * @returns {Array} Filtered stores matching active tags
 */
export const filterStoresByTags = (stores, activeTags) => {
  if (!activeTags || activeTags.size === 0) {
    return stores;
  }

  return stores.filter((store) => {
    if (!store.tags || !Array.isArray(store.tags)) {
      return false;
    }

    return store.tags.some((tag) => activeTags.has(tag.label));
  });
};
